// src/Routes/AdminRoutes.js
import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import {ProtectedComponent} from '../Pages/Authentication';
import {  RequestorHome , RequestNewSample } from '../Pages/Requestor';
import NotFoundPage from '../Components/NotFoundPage'; 
import { GlobalInfo } from '../Contexts/GlobalContext';
import NewRequest from '../Pages/Admin/Sample/NewRequest';
import AdminHome from '../Pages/Admin/AdminHome';
import ViewSampleRequestDetails from '../Pages/Admin/SampleRequests/ViewSampleRequestDetails';
import ParentStudiesHome from '../Pages/Requestor/ParentStudiesHome';

const RequestorRoutes = () => {
  const { isSidebarVisible } = useContext(GlobalInfo);
  const { isRestrictedPage  } = useContext(GlobalInfo);
  return (
    <div className={`${!isRestrictedPage ? 'el-middle' : ''} ${!isSidebarVisible ? 'collapsed-body' : ''}`}>
      <Routes>
      <Route path="/" element={<RequestorHome requiredRole="Requestor" />} />
        <Route path="dashboard" element={<RequestorHome requiredRole="Requestor" />} />

        <Route path="requestor-sample-requests" element={<RequestorHome requiredRole="Requestor" />} />
        <Route path="dashboard/viewdetails" element={<ViewSampleRequestDetails requiredRole="Requestor" />} />
        <Route path="requestor-sample-requests/viewdetails" element={<ViewSampleRequestDetails requiredRole="Requestor" />} />

        {/* <Route path="sample-requests" element={<RequestorHome requiredRole="Requestor" />} /> */}
        {/* <Route path="request-new-sample" element={<RequestNewSample requiredRole="Requestor" />} /> */}
        <Route path="request-new-sample" element={<NewRequest requiredRole="admin" />} />
        <Route path="parent-studies" element={<ParentStudiesHome requiredRole="admin" />} />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

export default RequestorRoutes;
